import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersSalesConceptCategoriesEditType } from "../../types";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersSalesConceptCategoriesEditType> => {
  const response =
    await new ApiClient().get<ApiManagersSalesConceptCategoriesEditType>(
      `/api/managers/sales_concept_categories/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersSalesConceptCategoriesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersSalesConceptCategoriesEditType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersSalesConceptCategoriesEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
